var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{staticClass:"cart-title",attrs:{"title":"课程更新进度","fixed":"","left-arrow":""},on:{"click-left":_vm.onBack}}),_c('van-empty',{attrs:{"image-size":"30rem","description":"暂未更新"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }